import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { EditorPage } from './pages/EditorPage';
import OrganizationList from './components/OrganizationList';
import ProjectList from './components/ProjectList';
import ProjectFiles from './components/ProjectFiles';
import FileEditor from './components/FileEditor';

function App() {
  return (
    <Router>
      <Routes>
        {/* Legacy routes */}
        <Route path="/edit" element={<EditorPage />} />
        <Route path="/edit/*" element={<EditorPage />} />
        
        {/* New SaaS routes */}
        <Route path="/" element={<Navigate to="/organizations" replace />} />
        <Route path="/organizations" element={<OrganizationList />} />
        <Route path="/organizations/:orgId" element={<ProjectList />} />
        <Route path="/projects/:projectId" element={<ProjectFiles />} />
        <Route path="/projects/:projectId/files/:fileId" element={<FileEditor />} />
      </Routes>
    </Router>
  );
}

export default App;
